import { useEffect, useRef, useState } from "react";
import Icon from "../../../../components/icon";
import { CheckIcon, PhotoIcon } from "@heroicons/react/24/outline";
import { uploadImage } from "../actions";
import clsx from "clsx";
import ProgressBar from "../../../../components/progress-bar";

export default function UploadImages({categoryId,onUploaded}:{categoryId:number,onUploaded:()=>void}) {
    const [images, setImages] = useState<{
        file: File,
        uploaded: boolean,
    }[]>([]);
    const ref= useRef<HTMLInputElement>(null);
    const [progress, setProgress] = useState(0);
    const [uploading, setUploading] = useState(false);
    const handleChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if(files){
            const newImages = Array.from(files).map((file)=>({file, uploaded:false}));
            setImages([...newImages]);
            handleUpload(newImages);
        }
    }
   
    const handleUpload = async(images: {file: File, uploaded: boolean}[]) => {
        setUploading(true);
        setProgress(0);
        for(const image of images){
            const result = await uploadImage(categoryId, image.file);
            if(result?.success){
                image.uploaded = true;
                setImages([...images]);
                setProgress(images.filter((image)=>image.uploaded).length *100 / images.length);
            }
        };
        setUploading(false);
        onUploaded();
    }
    if(!categoryId) return null;
  return (
    <div onClick={()=>ref.current?.click()} className="w-full bg-gray-100 p-4 rounded-md mt-4 cursor-pointer">
      <div className="flex flex-col items-center justify-between">
        <Icon icon={PhotoIcon} label="Upload Images"  size={12} className="text-gray-300" />
        <h1 className="text-2xl text-gray-500">Click to add Images</h1>
      </div>
      <div className="flex items-center justify-start gap-2">
        {images.map((image)=>(
            <div key={image.file.name} className={"w-20 relative"}>
                <img src={URL.createObjectURL(image.file)} alt={image.file.name} />    
                {image.uploaded ?
                <div className="absolute bottom-0 left-0 right-0 text-center text-sm flex items-center justify-center h-full">                    
                    <Icon icon={CheckIcon} label="Uploaded" size={8} className="text-green-500" />
                </div>:null}            
            </div>
        ))}
        <input ref={ref} type="file" className="w-full hidden" multiple accept="image/*" onChange={handleChange}   />
      </div>
      <ProgressBar progress={progress} />
    </div>
  );
}